import { render, staticRenderFns } from "./ModalSelectCustomer.vue?vue&type=template&id=22fff82e&scoped=true&"
import script from "./ModalSelectCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalSelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectCustomer.vue?vue&type=style&index=0&id=22fff82e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fff82e",
  null
  
)

export default component.exports